"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyTheme = void 0;
const react_1 = require("react");
const darkCssVariables_json_1 = __importDefault(require("./darkCssVariables.json"));
// This code hardcodes the dark theme, but was written so that
// light theme can be easily added as it is in tailwind-playground.
const applyTheme = () => {
    const root = document.documentElement;
    document.body.classList.add('hum');
    document.body.classList.add('dark');
    Object.keys(darkCssVariables_json_1.default).forEach((property) => {
        if (property === 'name') {
            return;
        }
        root.style.setProperty(property, darkCssVariables_json_1.default[property]);
    });
};
const useApplyTheme = () => {
    (0, react_1.useEffect)(() => {
        applyTheme();
    }, []);
};
exports.useApplyTheme = useApplyTheme;
//# sourceMappingURL=useApplyTheme.js.map